import React, { useState, useEffect } from "react";
import axios from "axios";
import { ItemListResponse } from "helpers/interfaces";

interface IDashboardContext {
    byStatusDashboard: IByStatusDashboard[]
    byAssigneeDashboard: ITicketsByAssigneeResponse[]
}

interface IByStatusDashboard {
    categoryId: string
    status: string
    count: number
}

interface ITicketsByAssigneeResponse {
    email: string
    name: string
    count: number
}

export let dashboardContext = React.createContext<IDashboardContext>({} as IDashboardContext);

let { Provider } = dashboardContext;

let DashboardProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let [byStatusDashboard, setByStatusDashboard] = useState<IByStatusDashboard[]>([]);
    let [byAssigneeDashboard, setByAssigneeDashboard] = useState<ITicketsByAssigneeResponse[]>([])

    useEffect(() => {
        getDashboardByStatus();
        getDashboardByAssignee()
    }, [])


    let getDashboardByStatus = async () => {
        try {
            let res = await axios.get<ItemListResponse<IByStatusDashboard>>('/api/Ticket/GetTicketsByCategoryAndStatus')
            setByStatusDashboard(res.data.items);
        } catch (err) { }
        finally {

        }
    }

    let getDashboardByAssignee = async () => {
        try {
            let res = await axios.get<ItemListResponse<ITicketsByAssigneeResponse>>('/api/Ticket/GetTicketsByAssignee')
            setByAssigneeDashboard(res.data.items);
        } catch (err) { }
        finally {

        }
    }

    return (
        <Provider value={{
            byStatusDashboard,
            byAssigneeDashboard,
        }}>
            {children}
        </Provider>
    );
};

export default DashboardProvider;